import { StaticReference } from '@edgebox/data-definition-kit';
import { MonitoringPromptCountry, TaxonomyTermOrigin } from '@edgebox/sync-core-data-definitions';
import { ClientLocaleEntity, ClientTaxonomyTermDraft } from '@edgebox/sync-core-rest-client';

/** Every country the monitoring asks prompts in, by the ISO code a locale's country carries. */
const MONITORED_COUNTRIES = new Set<string>(Object.values(MonitoringPromptCountry));

/**
 * The country a locale lets prompts be asked in, or undefined when it names none the monitoring runs
 * in. Sync Core pairs a locale tag with the country of its locale the same way, so a locale without
 * such a country gives a prompt no country and language, and a recommended set asked nowhere cannot
 * be created.
 */
export function monitoredCountryOf(locale: ClientLocaleEntity): MonitoringPromptCountry | undefined {
  const code = locale.country?.code?.toUpperCase();
  return code && MONITORED_COUNTRIES.has(code) ? (code as MonitoringPromptCountry) : undefined;
}

/**
 * Backs a new locale tag with its locale: the tag names a locale rather than anything an editor wrote,
 * so it is the system's, and the locale is what Sync Core reads the tag's language and country from.
 * The settings create path and the onboarding wizard both create locale tags through here.
 */
export function applyTermLocale(draft: ClientTaxonomyTermDraft, locale: ClientLocaleEntity): void {
  draft.origin = TaxonomyTermOrigin.System;
  draft.locale = new StaticReference(locale);
}
